import { useCallback, useMemo } from "react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { ChartDatesListFragment } from "@ihr-radioedit/inferno-webapi";
import { parseChartDates } from "../../services/Charts";
import { Container, Select } from "../../ui";

const numberToMonth = {
  0: "month-january",
  1: "month-february",
  2: "month-march",
  3: "month-april",
  4: "month-may",
  5: "month-june",
  6: "month-july",
  7: "month-august",
  8: "month-september",
  9: "month-october",
  10: "month-november",
  11: "month-december",
};

interface ChartListsCollectionFilterProps {
  chartDates?: ChartDatesListFragment | null;
  setMonth: (v: number | null) => void;
  setYear: (v: number | null) => void;
  month: number | null;
  year: number | null;
}

export const ChartListsCollectionFilter = ({
  chartDates,
  setMonth,
  setYear,
  month,
  year,
}: ChartListsCollectionFilterProps) => {
  const { t } = useTranslation();

  const parsedDates = useMemo(() => parseChartDates(chartDates), [chartDates]);

  const yearsItems = useMemo(
    () =>
      parsedDates?.years?.reduce(
        (acc, cur) => {
          acc[cur.toString()] = cur.toString();
          return acc;
        },
        { "": t("select_year") } as { [k: string]: string },
      ),
    [parsedDates, t],
  );

  const monthItems = useMemo(
    () =>
      year
        ? parsedDates?.monthsByYear?.[year]?.reduce(
            (acc, cur) => {
              acc[cur.toString()] = t(numberToMonth[cur]);
              return acc;
            },
            { "": t("select_month") } as { [k: string]: string },
          )
        : null,
    [year, parsedDates, t],
  );

  const handleYearUpdate = useCallback(
    (e: React.SyntheticEvent) => {
      e.preventDefault();

      const val = (e.target as HTMLInputElement).value;

      if (month !== null) {
        setMonth(null);
      }

      setYear(val ? Number(val) : null);
    },
    [month, setYear, setMonth],
  );

  const handleMonthUpdate = useCallback(
    (e: React.SyntheticEvent) => {
      e.preventDefault();

      const val = (e.target as HTMLInputElement).value;
      setMonth(val ? Number(val) : null);
    },
    [setMonth],
  );

  return (
    <Container className="component-chart-lists-collection-filter">
      {yearsItems ? <Select items={yearsItems} selected={year ? year.toString() : ""} cb={handleYearUpdate} /> : null}
      {monthItems ? (
        <Select items={monthItems} selected={month ? month.toString() : ""} cb={handleMonthUpdate} />
      ) : null}
    </Container>
  );
};
